import { isMusicVideoDocSizeOk, MUSIC_VIDEO_MAX_CLIPS, type MusicVideoDoc } from 'fym-shared/src/music24/musicVideoDoc';

/**
 * Which stored limit a change would pass: `clips` (`MUSIC_VIDEO_MAX_CLIPS`) or `size`
 * (`MUSIC_VIDEO_DOC_MAX_BYTES`, `isMusicVideoDocSizeOk`).
 */
export type MusicVideoDocLimit = 'clips' | 'size';

/**
 * The limit that the change from `before` to `after` passes, or null. The API refuses a document
 * over a limit (`M24_CUT_DOC_INVALID`), so the editor refuses the change itself and never sends it.
 * A change that does not grow the document passes (a document over a limit from before can still
 * shrink). Pure.
 */
export function docLimitRefusal(before: MusicVideoDoc, after: MusicVideoDoc): MusicVideoDocLimit | null {
  if (after.clips.length > MUSIC_VIDEO_MAX_CLIPS && after.clips.length > before.clips.length) {
    return 'clips';
  }
  if (!isMusicVideoDocSizeOk(after) && JSON.stringify(after).length > JSON.stringify(before).length) {
    return 'size';
  }
  return null;
}
